import { render, staticRenderFns } from "./other.vue?vue&type=template&id=38c4ead2&"
import script from "./other.vue?vue&type=script&lang=js&"
export * from "./other.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports